import React, { useState, useEffect } from "react";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CircularProgress from "@material-ui/core/CircularProgress";
import Axios from "axios";
import debounce from "lodash.debounce";

const MedicineSelector = (props) => {
	const [options, setOptions] = useState([]);
	const [loading, setLoading] = useState(false);
	const [inputValue, setInputValue] = useState("");

	const fetchMedicines = debounce(async () => {
		setLoading(true);
		try {
			const { data } = await Axios.get(
				`/api/doctor/medicines?q=${inputValue}&consultation_id=${props.consultation_id}`
			);
			if (data.success && data.medications.length > 0) {
				setOptions(data.medications);
			}
		} catch (error) {
			console.log(error);
		} finally {
			setLoading(false);
		}
	}, 200);

	useEffect(() => {
		if (inputValue && inputValue.length >= 2) {
			fetchMedicines();
		} else if (inputValue === "") {
			setOptions([]);
		}
	}, [inputValue]);

	useEffect(() => {
		if (props.value && props.value.id !== null) {
			setInputValue(props.value.name);
		}
	}, [props.value]);

	return (
		<div className="form-group boxed pd-l-r-16">
			<Autocomplete
				id="medicine-selector"
				style={{ width: "100%" }}
				value={props.value}
				options={options}
				loading={loading}
				getOptionSelected={(option, value) => option.name === value.name}
				getOptionLabel={(option) => (option.name ? option.name : "")}
				onChange={(e, newValue) => {
					props.setValue(newValue);
				}}
				onInputChange={(event, newInputValue) => {
					if (newInputValue === "") {
						props.setValue({ code: null, id: null, name: null });
					}
					setInputValue(newInputValue);
				}}
				renderInput={(params) => (
					<TextField
						{...params}
						label="Medicine name"
						variant="outlined"
						InputProps={{
							...params.InputProps,
							endAdornment: (
								<React.Fragment>
									{loading ? <CircularProgress color="inherit" size={20} /> : null}
									{params.InputProps.endAdornment}
								</React.Fragment>
							),
						}}
					/>
				)}
			/>
		</div>
	);
};

export default MedicineSelector;
